export default __webpack_public_path__ + "media/images/18-e4cf03d85865fc3859cd08f1ec34b0d2.jpg";